import { fromBaseClone, fromBaseRecord } from './from-base-context';
import type { FromBaseRow as Row } from './from-base-context';
import { readItemField } from './item-field-reader';
import { phpJsonTruthy } from './php-json-values';

/** Served-only PL pending projection after a definition's storage round trip.
 * Storage removes the pending fields; reading appends them after retained values.
 * The storage round trip drops the carry signature and retains the browser signature. */
export function projectDefinitionPendingCacheRead(source: Row): Row {
    const result = fromBaseClone(source);
    function walk(node: Row | unknown[]): void {
        const row = node as Row;
        if (fromBaseRecord(row.computed) && phpJsonTruthy(readItemField(row.computed, 'pl_pending'))) {
            const computed = { ...row.computed };
            delete computed.pl; delete computed.pl_pending;
            if (fromBaseRecord(computed._cache)) {
                const cache = { ...computed._cache };
                delete cache.pl_sig;
                computed._cache = cache;
            }
            row.computed = { ...computed, pl: null, pl_pending: 1 };
        }
        for (const value of Object.values(node)) if (value !== null && typeof value === 'object') walk(value as Row);
    }
    walk(result);
    return result;
}
